import { AssignmentOutlined } from '@mui/icons-material'

import { useDispatch, useSelector } from '@tabeeb/store'
import { Chip, ConfirmationDialog, useDialogState } from '@collaborate-health/uikit'

import { FormButtons } from '@tabeeb/modules/forms/services/enums'
import { getFormButtonState } from '@tabeeb/modules/forms/selectors'
import { setInitialValues } from '@tabeeb/modules/forms/actions'

const InitialValuesButton: React.FC = () => {
  const dispatch = useDispatch()
  const [open, onOpen, onClose] = useDialogState()

  const { isVisible, isDisabled } = useSelector((state) =>
    getFormButtonState(state, { button: FormButtons.SetInitialValues })
  )

  if (!isVisible) {
    return null
  }

  return (
    <>
      <Chip
        disabled={isDisabled}
        icon={<AssignmentOutlined />}
        color='primary'
        label='Set initial values'
        onClick={onOpen}
      />

      <ConfirmationDialog
        isOpen={open}
        title='Are you sure you want to set initial values to empty input fields?'
        cancelButtonText='No'
        submitButtonText='Yes'
        onCloseDialog={onClose}
        onSubmit={() => {
          dispatch(setInitialValues())
          onClose()
        }}
      />
    </>
  )
}

export default InitialValuesButton

